import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=5b7b43c7&scoped=true&"
import script from "./Total.vue?vue&type=script&lang=ts&"
export * from "./Total.vue?vue&type=script&lang=ts&"
import style0 from "./Total.vue?vue&type=style&index=0&id=5b7b43c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b43c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
